import { IonItem, IonLabel, IonText, useIonRouter } from '@ionic/react';
import { truncatePostText } from '../utils/postDate';

interface DraftListItemProps {
  channelId: string;
  draft: {
    id: string;
    text: string;
  };
}

// One draft row. Tapping it opens the editor for that draft.
export const DraftListItem = ({ channelId, draft }: DraftListItemProps) => {
  const ionRouter = useIonRouter();
  const { preview } = truncatePostText(draft.text);
  const label = preview.length > 0 ? preview : '(Borrador vacío)';

  return (
    <IonItem
      button
      detail
      lines="full"
      style={{
        '--padding-top': '14px',
        '--padding-bottom': '14px',
      } as React.CSSProperties}
      onClick={() => ionRouter.push(`/app/main/channels/${channelId}/publicar/${draft.id}`)}
    >
      <IonLabel className="ion-text-wrap">
        <IonText className="whitespace-pre-line">{label}</IonText>
      </IonLabel>
    </IonItem>
  );
};
